export default __webpack_public_path__ + "static/media/BeforePhoto7.f3d32369.jpg";